"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Actions;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ActionsModule = _interopRequireDefault(require("./Actions.module.scss"));

var _Button = _interopRequireDefault(require("../../../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Actions(_ref) {
  var onClickAttack = _ref.onClickAttack,
      onClickStop = _ref.onClickStop,
      onClickHoldPos = _ref.onClickHoldPos,
      onClickFollow = _ref.onClickFollow,
      onClickDismiss = _ref.onClickDismiss,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ActionsModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ActionsModule.default.btn, _ActionsModule.default.attack)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.HIRING_PET_ATTACK_26X26,
    onClick: function onClick() {
      if (onClickAttack) onClickAttack();
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ActionsModule.default.btn, _ActionsModule.default.stop)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.HIRING_PET_MOTIONSTOP_26X26,
    onClick: function onClick() {
      if (onClickStop) onClickStop();
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ActionsModule.default.btn, _ActionsModule.default.holdpos)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.HIRING_PET_POSITION_26X26,
    onClick: function onClick() {
      if (onClickHoldPos) onClickHoldPos();
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ActionsModule.default.btn, _ActionsModule.default.follow)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.HIRING_PET_FOLLOW_26X26,
    onClick: function onClick() {
      if (onClickFollow) onClickFollow();
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ActionsModule.default.btn, _ActionsModule.default.dismiss)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.HIRING_PET_ENDING_26X26,
    onClick: function onClick() {
      if (onClickDismiss) onClickDismiss();
    }
  })));
}